import { render, staticRenderFns } from "./compras.vue?vue&type=template&id=9652f7f0&scoped=true"
import script from "./compras.vue?vue&type=script&lang=js"
export * from "./compras.vue?vue&type=script&lang=js"
import style0 from "./compras.vue?vue&type=style&index=0&id=9652f7f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9652f7f0",
  null
  
)

export default component.exports